import React from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from 'dripsy';
import { View } from 'react-native';
import { observer } from 'mobx-react-lite';

import { CheckBox, IconTouchable, Separator } from '@components';
import { useNavOptionsSet } from '@hooks';
import { PaymentMethod } from '@models/Viewer/PaymentMethodModel';
import { ToastService } from '@services';
import { parseApiError } from '@utils';
import { PaymentMethodItemProps } from './PaymentMethodItemProps';

const Container = styled(View)({ flex: 1 });

interface IBoxContainerStyleProps {
  isDefault?: boolean;
}

const BoxContainer = styled(View)(
  (props: IBoxContainerStyleProps) => ({
    bg: '$background10',
    pl: '$8',
    borderRadius: 6,
    borderWidth: 1,
    borderColor: props.isDefault ? '$primary300' : '$background10',
    flexDirection: 'row',
    justifyContent: 'space-between',
    minHeight: 170,
  }),
);

const PropContainer = styled(View)({
  width: 310,
});

const ActionsRow = styled(View)({
  flexDirection: 'row',
});

const ActionTouchableContainer = styled(View)({
  size: 56,
  alignItems: 'center',
  justifyContent: 'center',
});

interface IPaymentMethodItemProps {
  item: PaymentMethod;
  onPressDelete(item: PaymentMethod): void;
}

export const PaymentMethodItem = observer<IPaymentMethodItemProps>(
  ({ item, onPressDelete }) => {
    const { t } = useTranslation();

    useNavOptionsSet({ title: t('creditCards.title') });

    async function setAsDefault() {
      try {
        await item.setAsDefault.run();
      } catch (error) {
        ToastService.showError(parseApiError(error).message);
      }
    }

    return (
      <Container>
        <BoxContainer isDefault={item.isDefault}>
          <PropContainer>
            <Separator size="$7" />
            <PaymentMethodItemProps item={item} />
            <Separator size="$7" />
          </PropContainer>

          <ActionsRow>
            {/* <ActionTouchableContainer>
              <IconTouchable
                name="edit-light"
                size={20}
                color="$heading800"
                onPress={() => onPressEdit(item)}
              />
            </ActionTouchableContainer> */}

            <ActionTouchableContainer>
              <IconTouchable
                name="delete-light"
                size={20}
                color="$error300"
                onPress={() => onPressDelete(item)}
              />
            </ActionTouchableContainer>
          </ActionsRow>
        </BoxContainer>

        <Separator size="$4" />

        <CheckBox
          text={t('creditCards.setAsDefault')}
          value={item.isDefault}
          onPress={setAsDefault}
          disabled={item.isDefault}
        />
      </Container>
    );
  },
);
